import { useState, useMemo } from 'react';
import { FieldAttributes } from 'formik';
import {
    DateTimePicker as MuiDateTimePicker,
    DateTimePickerProps,
} from 'formik-mui-x-date-pickers';
import { DateTimeValidationError } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';

import { getDateTimeFormat } from 'common/utils/getDateFormat';
import { valueToDateTime } from 'common/utils/formatDate';

export const DateTimePicker = ({
    label,
    value,
    ...other
}: FieldAttributes<DateTimePickerProps>) => {
    const dateFormat = getDateTimeFormat();
    const [translate] = useTranslation();

    const [error, setError] = useState<DateTimeValidationError | null>(null);

    const errorMessage = useMemo(() => {
        switch (error) {
            case 'maxDate':
                return translate('maxDateMessage');

            case 'minDate':
                return translate('minDateMessage');

            case 'invalidDate': {
                return translate('invalidDateMessage');
            }

            default:
                return '';
        }
    }, [error]);

    const { field } = other;
    const fieldValue = value || field.value;

    // Make sure we have a luxon DateTime object
    field.value = valueToDateTime(fieldValue);

    return (
        <MuiDateTimePicker
            ampm={false}
            format={dateFormat}
            slotProps={{
                textField: {
                    fullWidth: true,
                    margin: 'normal',
                    label: label,
                    helperText: errorMessage,
                    sx: {
                        '& .MuiPickersInputBase-sectionsContainer': {
                            py: 2,
                        },
                    },
                },
            }}
            onError={(newError) => setError(newError)}
            {...other}
        />
    );
};
